import { H2RSelect, definitions } from "../imports";
import { transitionOptions } from "../templates/styles";
import ThemeSelectorDropdown from "./ThemeSelectorDropdown";

export default function CueEditTheme({ cue, onUpdate, themes, selectedTheme }) {
	return (
		<>
			<ThemeSelectorDropdown
				themes={themes}
				selectedTheme={
					[undefined, null, ""].includes(cue.theme)
						? themes[selectedTheme]
						: themes[cue.theme]
				}
				projectDefaultTheme={selectedTheme}
				onChange={(change) => {
					onUpdate({ theme: change });
				}}
			/>
			<H2RSelect
				label="Transition override"
				selected={cue.transition === undefined ? "use-theme" : cue.transition}
				options={[
					{
						label: "Use theme transition (default)",
						value: "use-theme",
					},
					...Object.entries(transitionOptions).map(([id, transition]) => {
						return {
							label: transition.label,
							value: transition.value,
						};
					}),
				]}
				onChange={(change) => {
					onUpdate({ transition: change });
				}}
				disabled={definitions[cue.type].transitionOverrideDisabled}
			/>
		</>
	);
}
